export enum AddResourceDialogModes {
  LOADING = 0,
  ADD = 1,
  CREATE = 2
}

export interface AddResourceDialogPayload {
  isArchitecture: boolean;
  attachedResources: [];
  isPro: boolean;
  uploadIconUrl: string;
  teamId: string;
}
